export default {
  selectedStoreCardId: '',

  storeCardList: [],
};



// WEBPACK FOOTER //
// ./src/app/store-cards/store/state.js